var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureNotAssigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 455.666,
    height: 278.028,
    viewBox: "0 0 455.666 278.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2074",
    x: 102.5,
    y: 13.942,
    width: 260.142,
    height: 260.142,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2605",
    "data-name": "Group 2605",
    transform: "translate(-199 -224.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2219",
    "data-name": "Group 2219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Untitled",
    transform: "translate(199 209.158)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 6.079,
    cy: 6.079,
    rx: 6.079,
    ry: 6.079,
    transform: "translate(114.784 14.843)",
    fill: "#e1e4e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 8.781,
    cy: 8.781,
    rx: 8.781,
    ry: 8.781,
    transform: "translate(372.135 36.046)",
    fill: "#e1e4e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 6.683,
    cy: 6.683,
    rx: 6.683,
    ry: 6.683,
    transform: "translate(0 44.089)",
    fill: "#e1e4e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 6.673,
    cy: 6.673,
    rx: 6.673,
    ry: 6.673,
    transform: "translate(442.321 267.261) rotate(-90)",
    fill: "#e1e4e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 8.876,
    cy: 8.876,
    rx: 8.876,
    ry: 8.876,
    transform: "translate(328.999 275.119)",
    fill: "#e1e4e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 6.828,
    cy: 5.463,
    rx: 6.828,
    ry: 5.463,
    transform: "translate(65.068 104.77)",
    fill: "#e1e4e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 8.51,
    cy: 8.51,
    rx: 8.51,
    ry: 8.51,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 108.953, 271.105)",
    fill: "#e1e4e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M423.66,169.951h-.093c-.553-8.137-6.38-8.262-6.38-8.262s6.424-.13,6.424-9.531c0,9.4,6.426,9.531,6.426,9.531S424.214,161.814,423.66,169.951Z",
    transform: "translate(15.629 -101.489)",
    fill: "#e1e4e5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2225",
    "data-name": "Group 2225",
    transform: "translate(-1111.5 214.943)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1310.5, 9.06)",
    filter: "url(#Path_2074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2074-2",
    "data-name": "Path 2074",
    d: "M113.571,0A113.571,113.571,0,1,1,0,113.571,113.571,113.571,0,0,1,113.571,0Z",
    transform: "translate(114 25.44)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M2,101.721H163.2v16.12H2ZM97.431,27.488a16.63,16.63,0,0,0,1.29-6.367,16.12,16.12,0,1,0-32.24,0,16.63,16.63,0,0,0,1.29,6.367A72.636,72.636,0,0,0,10.06,93.661H155.141a71.99,71.99,0,0,0-9.807-31.8c-.67-1.141-1.405-2.316-2.173-3.469A73.2,73.2,0,0,0,113.415,32.8c-.913-.429-1.924-.877-2.946-1.3A72.176,72.176,0,0,0,97.431,27.488Z",
    transform: "translate(1454.949 88.909)",
    fill: "#4153b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M32.877,2A30.877,30.877,0,1,0,63.753,32.877,30.888,30.888,0,0,0,32.877,2ZM48.315,35.964H17.438V29.789H48.315Z",
    transform: "translate(1554.399 86.573)",
    fill: "#bf6087"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureNotAssigned);
export default __webpack_public_path__ + "static/media/feature_not_assigned.d3c0f55b3bfae0867a8bc0c48869ab68.svg";
export { ForwardRef as ReactComponent };